import filters from "./filters";
import { store } from "../../store/store.js";
import utils from "@/components/utils/utils";

/*******************************************************************
 * THE OPTIONS AND PROPERTIES NEED TO BE FETCHED IN COMPONENT/PAGE *
 * *****************************************************************/

function isAddressRentLike(address){
  let ownership = address.ownership;
  const properties = store.getters.properties.address_history_ownership_properties;
  let property = properties[ownership];
  return property ? property.renting : false;
}

function hasSpouse(personal_details){
  const properties = store.getters.properties.personal_details_marital_status_properties;
  let marital_status = personal_details.marital_status;
  let property = properties[marital_status];
  return property ? (property.has_spouse == '1' ? true : false) : false;
}

function hasVedaReport(vedareport_details) {
  return  (vedareport_details && vedareport_details.success == true) ? true : false;
}

function loanValidation(loan){
  return {};
}

function contactDetailsValidation(contacts, personal_details){

  // age test
  let dates_of_birth = contacts.map(c => new Date(c.date_of_birth));
  let ages = dates_of_birth.map(dob => Math.floor((new Date() - new Date(dob)) / 365/24/60/60/1000));
  let age_problems = ages.map((age, i) => {
    if(age < 18)
      return `Applicant ${i+1} under 18`;
    if(age > 75)
      return `Applicant ${i+1} over 75`;
    return null;
  });
  age_problems = age_problems.filter(p => p!=null);

  // whether to show spouses details, if any applicant has a spouse, show group row
  let to_show_spouse_details = personal_details.some(pd => hasSpouse(pd));

  return {
    age: {
      notes: age_problems
    },
    to_show_spouse_details,
  };
}

function privacyConsentValidation(privacy_consent){
  return {};
}

function addressesValidation(applicants, addresses){

  const addresses_tenure = addressesTenureValidation(addresses);
  let problems = [];
  if(addresses_tenure.total < 36)
    problems.push('Less than 3 years address history');

  // whether to show rent details, if any applicant has a spouse, show group row
  let to_show_rent_details = addresses.some(a => isAddressRentLike(a.current));

  let perApplicantRentExpense = [];
  let totalRentExpense = 0;
  applicants.forEach((applicant, applicantIndex) => {
    let expense = 0;
    if(applicant.addresses.current.ownership == 'Rented' || applicant.addresses.current.ownership == 'Boarded'){
      expense = filters.toMonthlyAmount(applicant.addresses.current.expense.amount, applicant.addresses.current.expense.frequency)
    }
    totalRentExpense += expense;
    perApplicantRentExpense.push({
      applicantId: applicant.id || applicantIndex,
      expense: expense
    })
  });

  return {
    notes: problems,
    expense: totalRentExpense,
    total_duration: addresses_tenure.total,
    to_show_rent_details,
    perApplicantRentExpense
  };
}

function addressesTenureValidation(addresses) {
  // total address duration
  let current_durations  = (addresses[0].current.duration.years * 12) + Number(addresses[0].current.duration.months);
  let previous_durations = addresses[0].previous.map(address => (address.duration.years * 12) + Number(address.duration.months));
  let sum_previous_durations = previous_durations.reduce((a,b) => Number(a)+Number(b), 0);
  let continuus_durations = current_durations + sum_previous_durations;
  return {
    current: current_durations,
    previous: sum_previous_durations,
    total: continuus_durations,
  } 
}

function employmentsValidation(applicants, employments, personal_details) {

  // total employment duration
  let current_durations = employments[0].current.map(employment => (employment.duration.years * 12) + Number(employment.duration.months));
  let previous_durations = employments[0].previous.map(employment => (employment.duration.years * 12) + Number(employment.duration.months));
  let max_current_durations = current_durations.reduce((a, b) => Number(a) > Number(b) ? a : b, 0);
  let sum_previous_durations = previous_durations.reduce((a, b) => Number(a) + Number(b), 0);
  let continuus_durations = max_current_durations + sum_previous_durations;

  // spouses employment income
  let spouse_employments = personal_details.map((pd) => {
    return {
      employment: pd.spouse.employment,
      hasSpouse: hasSpouse(pd)
    };
  });
  spouse_employments = spouse_employments.filter(e => e.hasSpouse);
  let spouse_incomes = spouse_employments.map(e => filters.toMonthlyAmount(e.employment.income.amount, e.employment.income.frequency));
  const spouse_income  = spouse_incomes.reduce((a,b) => Number(a)+Number(b), 0);

  const incomeArr = [];
  let income = 0;
  applicants.forEach((applicant, applicantIndex) => {
    let currentEmployments = applicant.employments.current;
    let totalCurrentEmploymentIncome = 0;
    currentEmployments.forEach(employment => {
      totalCurrentEmploymentIncome += filters.toMonthlyAmount(employment.income.amount, employment.income.frequency)
    });
    let individualIncome = {
      'applicantId': applicant.id || applicantIndex,
      'employment': totalCurrentEmploymentIncome,
      'spouse': 0
    };
    income += individualIncome['employment'];
    if (hasSpouse(applicant.personal_details)) {
      // when spouse is not marked as applicant
      if (!applicant.personal_details.spouse.spouse_applicant_id && !applicant.personal_details.spouse_index) {
        const spouseIncome = applicant.personal_details.spouse.employment.income;
        individualIncome['spouse'] = filters.toMonthlyAmount(spouseIncome.amount, spouseIncome.frequency)
        income += individualIncome['spouse'];
      }
    }
    incomeArr.push(individualIncome);
  });
  return {
    max_current_durations,
    sum_previous_durations,
    continuus_durations,
    income,
    spouse_income,
    incomeArr
  };
}

function otherIncomesValidation(applicants) {
  const incomes = [];
  let total = 0;

  applicants.forEach((applicant, applicantIndex) => {
    let value = 0;
    applicant.incomes.forEach((income) => {
      value += filters.toMonthlyAmount(income.amount, income.frequency);
    })
    total += value;
    incomes.push({
      'applicantId': applicant.id || applicantIndex,
      'otherIncomeValue': value
    });
  })
  return {
    total,
    incomes,
  };
}

function expensesValidation(applicants){

  // other expenses
  let totalExpenseAmount = 0;
  let expensesPerApplicant = [];
  applicants.forEach((applicant, applicantIndex) => {
    let expenseValue = 0;
    applicant.expenses.forEach(expense => {
      expenseValue += Number(filters.toMonthlyAmount(expense.amount, expense.frequency));
    })
    expensesPerApplicant.push({
      applicantId: applicant.id || applicantIndex,
      expense: expenseValue
    });
    totalExpenseAmount += expenseValue;
  });
  return {
    total: totalExpenseAmount,
    perApplicant: expensesPerApplicant
  };
}

function assetsValidation(applicants, assets){

  // total value
  let values = assets.map(_assets => _assets.map(asset => asset.value));
  values = values.map(_value => filters.toMonthlyAmount(_value));
  const total = values.reduce((a,b) => Number(a)+Number(b), 0);

  const assetsIncome = [];
  let income = 0;
  let expense = 0;
  applicants.forEach((applicant, applicantIndex) => {
    if (applicant.assets && applicant.assets.length > 0) {
      let assetIncome = 0;
      let liabilityExpense = 0;
      applicant.assets.forEach(asset => {
        if (asset.has_income) {
          assetIncome += filters.toMonthlyAmount(asset.income.amount, asset.income.frequency)
        }
        if (asset.has_liability) {
          liabilityExpense += filters.toMonthlyAmount(asset.expense.amount, asset.expense.frequency)
        }
      });
      income += assetIncome;
      expense += liabilityExpense;
      assetsIncome.push({
        'applicantId': applicant.id || applicantIndex,
        'assetIncome': assetIncome,
        'liabilityExpense': liabilityExpense
      });
    }
  })

  let liabilities = assets.map(_assets => _assets.map(asset => asset.has_liability));
  let has_liability = 0;
  liabilities = liabilities.map((liability, i) => {
    if(liability  == "true"){
      has_liability  = has_liability+1;
    }
    return has_liability;
  });
  let incomes_has = assets.map(_assets => _assets.map(asset => asset.has_income));
  let has_incomes = 0;
  incomes_has = incomes_has.map((_incomes, i) => {
    if(_incomes  == "true"){
      has_incomes  = has_incomes+1;
    }
    return has_incomes;
  });

  return {
    total,
    income,
    expense,
    has_incomes,
    has_liability,
    assetsIncome
  };
}

function referencesValidation(references){
  return {};
}

function vedaReportValidation(veda_report){
  return {};
}

function capacityValidation(validation){
  // get all incomes and expenses
  // console.log(validation.incomes.total, validation.employments.income, validation.employments.spouse_income, validation.assets.income, validation.incomes.total + validation.employments.income + validation.employments.spouse_income + validation.assets.income);
  let total_income = validation.otherIncomes.total + validation.employments.income + validation.assets.income;
  let total_expenses =  validation.expenses.total + validation.assets.expense + validation.addresses.expense;
  let uncommitted_income = total_income - total_expenses;
  let surplus_amount = validation.submissions;

  // low capacity warnings
  let notes = [];
  if(uncommitted_income < 0)
    notes.push('Negative Uncommitted Income');
  else if(uncommitted_income < 200)
    notes.push('Uncommitted Income < $200');

  return {
    income: total_income,
    expense: total_expenses,
    uncommitted_income,
    notes,
    surplus_amount,
  };
}

function applicationValidation(application_data){

  if(!application_data){
    return {};
  }

  let loan           = application_data.loan;
  // map category out of applicants array (application_data.[applicants].contact_details => [contact_details])
  let contact         = application_data.applicants.map(a => a.contact);
  let personal_details = application_data.applicants.map(a => a.personal_details);
  let privacyConsent  = application_data.applicants.map(a => a.privacy_consent);
  let addresses       = application_data.applicants.map(a => a.addresses);
  let employments     = application_data.applicants.map(a => a.employments);
  let incomes         = application_data.applicants.map(a => a.incomes);
  let expenses        = application_data.applicants.map(a => a.expenses);
  let assets          = application_data.applicants.map(a => a.assets);
  let references      = application_data.applicants.map(a => a.references);
  let vedaReport      = application_data.applicants.map(a => a.veda_report);
  let submissionData      = application_data.loan.submission;

  let validation = {};
  validation.loan             = loanValidation(           loan);
  validation.contact_details  = contactDetailsValidation( contact, personal_details);
  validation.privacy_consent  = privacyConsentValidation( privacyConsent);
  validation.addresses        = addressesValidation(      application_data.applicants, addresses);
  validation.employments      = employmentsValidation(    application_data.applicants, employments, personal_details);
  validation.assets           = assetsValidation(         application_data.applicants, assets);
  validation.otherIncomes     = otherIncomesValidation(application_data.applicants);
  validation.expenses         = expensesValidation(application_data.applicants);
  validation.references       = referencesValidation(     references);
  validation.vedaReport       = vedaReportValidation(     vedaReport);
  validation.submissions      = submissionDetails(submissionData);
  validation.capacity         = capacityValidation(       validation);
  validation.living_expenses  = hemExpenses(application_data.applicants);
  return validation;
}

function submissionDetails(submissionData) {
  if (!submissionData) {
    return null;
  }
  let amount = submissionData.previous.map(a => a.naf);
  let anual_rate = submissionData.previous.map(a => a.rate);
  let monthly_account_fee = submissionData.previous.map(a => a.monthly_account_fee);
  let term = submissionData.previous.map(a => a.term);
  let repayment_frequency = submissionData.previous.map(a => a.payment_frequency);
  let balloon_amount = submissionData.previous.map(a => a.balloon_amount);
  let repayment_type = submissionData.previous.map(a => a.repayment_type);
  return utils.calculateRepayments(
    amount,
    anual_rate,
    term,
    "Monthly",
    repayment_frequency,
    monthly_account_fee,
    balloon_amount,
    repayment_type,
  );
}

function submissionValidation(application_data){
  let assets = application_data.applicants.flatMap(a => a.assets);

  let saving_accounts = assets.filter(a => a.type == 'Savings');
  let total_savings = saving_accounts.reduce((sum, asset) => sum + filters.float(asset.value), 0);
  let deposit = application_data.loan.asset.vehicle.deposit_value;
  let saving_surplus = total_savings - deposit;
  let application_validation = applicationValidation(application_data);
  let disable_submit = false;

  let notes = [];
  if(saving_surplus < 0)
    notes.push('Too little savings to cover deposit');

  if (application_data.loan.submission.current.naf <= 0) {
    notes.push('No amount financed');
    disable_submit = true;
  }

  if (application_data.loan.submission.current.rate <= 0) {
    notes.push('Rate <= 0');
    disable_submit = true;
  }

  if (application_data.loan.submission.current.term <= 0) {
    notes.push('Term <= 0 Months');
    disable_submit = true;
  }

  if (application_data.loan.submission.current.repayments <= 0) {
    notes.push('Repayments <= $0');
    disable_submit = true;
  }

  return {
    capacity: application_validation.capacity,
    total_savings,
    saving_surplus,
    notes,
    disable_submit,
  };
}

/**
 * function to check if the surplus amount is greater than 0
 * @param application
 * @returns {boolean}
 */
function isSurplusMoreThanZero(application) {
  let totalIncome = applicationValidation(application).capacity.income;
  let totalExpense = applicationValidation(application).capacity.expense;
  return ((totalIncome - totalExpense) > 0);
}

function hemExpenses(applicants) {

  let min_single_expenses_amount = null;
  let min_married_expenses_amount = null;
  let dependant = null;

  let rules =  store.getters.properties.capacity_rules;
  if (rules !== undefined && rules !== null) {
    rules.forEach(item => {
      if (item['name'] == 'Hem') {
        if (item['type'] == 'Single' && item['rule'] == 'Base') {
          min_single_expenses_amount = item['value'];
        }
        else if (item['type'] == 'Couple' && item['rule'] == 'Base') {
          min_married_expenses_amount = item['value'];
        }
        else if (item['rule'] == 'Dependant') {
          dependant = item['value'];
        }
      }
    })
  }
  const personal_details = applicants[0].personal_details;
  const single_expenses = filters.converToInteger(min_single_expenses_amount ?? 1460);
  const joint_expenses = filters.converToInteger(min_married_expenses_amount ?? 2650);
  const dependant_expenses = filters.converToInteger(dependant ?? 370);
  if (hasSpouse(personal_details) || applicants.length > 1) {
    return joint_expenses + (personal_details.number_of_dependants * dependant_expenses);
  } else {
    return single_expenses + (personal_details.number_of_dependants * dependant_expenses);
  }
}

function minimumExpenses(applicants) {

  let min_single_expenses_amount = null;
  let min_married_expenses_amount = null;
  let dependant = null;

  let rules =  store.getters.properties.capacity_rules;
  if (rules !== undefined && rules !== null) {
    rules.forEach(item => {
      if (item['name'] == 'Hem Living Expense KO') {
        if (item['type'] == 'Single' && item['rule'] == 'Base') {
          min_single_expenses_amount = item['value'];
        }
        else if (item['type'] == 'Couple' && item['rule'] == 'Base') {
          min_married_expenses_amount = item['value'];
        }
        else if (item['rule'] == 'Dependant') {
          dependant = item['value'];
        }
      }
    })
  }
  const personal_details = applicants[0].personal_details;
  const single_expenses = filters.converToInteger(min_single_expenses_amount ?? 1105);
  const joint_expenses = filters.converToInteger(min_married_expenses_amount ?? 2040);
  const dependant_expenses = filters.converToInteger(dependant?? 230);
  if (hasSpouse(personal_details) || applicants.length > 1) {
    return joint_expenses + (personal_details.number_of_dependants * dependant_expenses);
  } else {
    return single_expenses + (personal_details.number_of_dependants * dependant_expenses);
  }
}

function uncommittedIncomeValidation(application) {
  const validation = applicationValidation(application);
  const personal_details = application.applicants[0].personal_details;
  const income = validation.capacity.income;

  // zink uncommitted income
  const capacity = capacityValidation(validation);
  const zinkUncommittedIncome = capacity.uncommitted_income;

  // Hem uncommitted income
  const hemExpense = hemExpenses(application.applicants);
  validation.expenses.total = hemExpense ?? 0;
  const hemCapacity = capacityValidation(validation);
  const hemUncommittedIncome = hemCapacity.uncommitted_income;

  // minimum uncommitted income
  const minimumExpense = minimumExpenses(application.applicants);
  validation.expenses.total = minimumExpense ?? 0;
  const minimumCapacity = capacityValidation(validation);
  const minimumUncommittedIncome = minimumCapacity.uncommitted_income;

  return {
    zinkUncommittedIncome,
    hemUncommittedIncome,
    minimumUncommittedIncome,
  };
}

export {
  isAddressRentLike,
  hasSpouse,
  applicationValidation,
  loanValidation,
  contactDetailsValidation,
  privacyConsentValidation,
  addressesValidation,
  addressesTenureValidation,
  employmentsValidation,
  otherIncomesValidation,
  expensesValidation,
  assetsValidation,
  referencesValidation,
  vedaReportValidation,
  submissionValidation,
  isSurplusMoreThanZero,
  submissionDetails,
  hasVedaReport,
  hemExpenses,
  uncommittedIncomeValidation,
}
